(function(angular, module) {var resolveConfig, resolveData, resovleGrantReport, resovleGrantReports, stateDefinitions;

stateDefinitions = function($stateProvider) {
  "ngInject";
  $stateProvider.state("program.amc_grant_report", {
    url: '/amc-grant-report',
    abstract: true,
    templateUrl: 'empty'
  });
  $stateProvider.state('program.amc_grant_report.index', {
    url: '',
    permission: 'viewAmcGrantReport',
    templateUrl: 'programs/initiatives/amcGrantReport/index',
    resolve: {
      grantReports: resovleGrantReports
    },
    controllerAs: 'ctrl',
    controller: function(grantReports) {
      this.grantReports = grantReports;
    }
  });
  return $stateProvider.state("program.amc_grant_report.view", {
    url: '/{grant_year:int}',
    templateUrl: 'programs/initiatives/amcGrantReport',
    permission: 'viewAmcGrantReport',
    resolve: {
      config: resolveConfig,
      grantReport: resovleGrantReport,
      data: resolveData
    },
    controllerAs: 'ctrl',
    controller: 'AmcGrantReportController'
  });
};


/* @ngInject */

resolveConfig = function($http, $stateParams, ApiUrl, momentConvertFilter) {
  var url;
  url = ApiUrl("amc_grant_report/config", $stateParams.grant_year);
  return $http.get(url).then(function(response) {
    return momentConvertFilter(response.data.item);
  });
};


/* @ngInject */

resovleGrantReports = function(ModelService, program) {
  return ModelService.getModelRelation(program, 'amc_grant_reports');
};


/* @ngInject */

resovleGrantReport = function($stateParams, program, ModelService) {
  var id;
  id = program.id + "/" + $stateParams.grant_year;
  return ModelService.get('amc_grant_report', id);
};


/* @ngInject */

resolveData = function($http, $stateParams, ApiUrl, program) {
  var url;
  url = ApiUrl('amc_grant_report', program.id, $stateParams.grant_year, 'data');
  return $http.get(url).then(function(response) {
    return response.data.item;
  });
};

module.config(stateDefinitions);
})(angular, angular.module("amcGrantReport"));